import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import {NavigationContainer} from '@react-navigation/native';
import { loadWebFonts } from './src/fonts';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import HomeScreen from './src/screens/Home';
import QRCode from './src/screens/QRCode';
import Preloader from './src/components/Preloader';

const Stack = createNativeStackNavigator();

const linking = {
  prefixes: ['https://ivyooo.com'],
  config: {
    screens: {
      Home: '',
      qrcode: 'qrcode/:code'
    }
  },
};

export default function App() {
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    loadWebFonts();
  }, []);

  return (
      <View style={styles.container}>
        <NavigationContainer linking={linking}>
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen name="Home" component={HomeScreen} />
            <Stack.Screen name="qrcode" component={QRCode} />
          </Stack.Navigator>
        </NavigationContainer>
        {booting && <Preloader onDone={() => setBooting(false)} />}
      </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: '100%',
    // backgroundColor: '#fff',
    // alignItems: 'center',
    // justifyContent: 'center',
  },
});
